'use strict'

jQuery( document ).ready( function ( $ ) {
	const AJAX_URL = 'wp-content/themes/JTF3/Lite/core/ajax_search.php'

	function SEARCH( thisInstance ) {
		console.log( '[JTF SEARCH - v2.17' )
		this.instance = thisInstance
		this.init()
		this.all_elements = []
	}

	/**
	 * Replace URL query variable with something else
	 *
	 * @param param
	 * @param newval
	 * @param search
	 * @returns {*}
	 */
	SEARCH.prototype.replaceQueryParam = function ( param, newval, search ) {
		var regex = new RegExp( "([?;&])" + param + "[^&;]*[;&]?" )
		var query = search.replace( regex, "$1" ).replace( /&$/, '' )

		return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '')
	}

	/**
	 * Default actions happening on device actions
	 */
	SEARCH.prototype.init = function () {
		const self = this

		$( '.searchajax__pagination a' ).click( function () {
			let direction = $( this ).attr( 'data-direction' )

			if ( direction == 'plus' ) {
				$( '.searchajax__pagination' )
			}
		} )

		$( '.search__offsite--button' ).on( 'click', function ( e ) {
			e.preventDefault()
			var searchTerm = $( this ).attr( 'data-term' )
			var input = $( this ).parent().find( 'input' ).val()

			$( '.search__offsite--title-copy' ).html( 'Results for \'' + input + '\'' )

			$( this ).attr( 'data-term', input )

			if ( searchTerm != input ) {
				searchTerm = input

				//TODO this doesn't work becuase you need to reload the page to apply it, but we don't want to reload the page
				//self.replaceQueryParam('s', searchTerm, window.location.search)
				//window.location = window.location.pathname + str
			}

			self.all_elements = []

			$( '.searchajax__check' ).each( function () {
				if ( $( this )[ 0 ].checked == true ) {
					self.get_external_posts( $( this ).attr( 'data-site' ), searchTerm )
				}
			} )

		} )
	}

	/**
	 * Re-order search items and flip them to highest results first
	 */
	SEARCH.prototype.order_results = function () {
		var self = this

		$( '.search__results' ).html( '' )
		$( '.search__offsite--count span' ).html( self.all_elements.length )

		self.all_elements.sort( ( a, b ) => a[ 0 ].attributes[ 1 ].value - b[ 0 ].attributes[ 1 ].value ) //Array sorter to plop all the items into value order
		self.all_elements.reverse() //needed because we want the largest items first and arrays count up not down

		$( '.search__results' ).html( self.all_elements )
	}

	/**
	 * Render all items to canvas
	 *
	 * @param json
	 * @param term
	 * @param target
	 */
	SEARCH.prototype.render_results = function ( json, term, target ) {
		var self = this

		const results = JSON.parse( json )
		//var all_elements = [];

		for ( let x = 0; x < results.length; x++ ) {
			const col = $( '<div/>',
				{
					'class': 'col-md-6 col-12 search__item',
					'data-result': results[ x ].relevance,
				},
			)
			const section = $( '<section/>',
				{
					'class': 'section',
				},
			)
			const h2 = $( '<h2/>',
				{
					'class': 'search__post-title',
				},
			)
			const p = $( '<p/>',
				{
					'class': '',
				},
			)
			const anchor = $( '<a/>',
				{
					'class': 'btn btn-default blue-btn',
					'href': results[ x ].permalink,
				},
			)

			let detailsContainer = $( '<div/>',
				{
					'class': 'search__term--details',
				},
			)

			let location = $( '<div/>',
				{
					'class': 'search__term--location',
				},
			)

			location.html( target )

			let occurance = $( '<div/>',
				{
					'class': 'search__term--occurrence',
				},
			)

			occurance.html( 'Found ' + results[ x ].relevance + ' times' )
			detailsContainer.html( location )


			let title = results[ x ].title
			let regEx = new RegExp( term, "ig" )
			let excerpt = results[ x ].excerpt

			if ( $.isArray( excerpt ) ) {
				excerpt = excerpt[ 0 ]
			}

			title = title.replace( regEx, '<span class="search-highlight">' + term + '</span>' )
			if ( excerpt != '' ) {
				excerpt = excerpt.replace( regEx, '<span class="search-highlight">' + term + '</span>' )
			} else {
				excerpt = 'no excerpt supplied'
			}

			anchor.text( 'Read more' )
			h2.html( title )
			p.html( excerpt )
			section.append( detailsContainer )
			section.append( occurance )
			section.append( h2 )
			section.append( p )
			section.append( anchor )
			col.append( section )

			/**
			 * we dont want any results that flag as 0 occurance, i mean why are they even returned as search results if they dont contain the bloody key word
			 */
			if ( results[ x ].relevance > 0 ) {
				self.all_elements.push( col )
			}
		}

		// const pagination_container = $('<div/>',
		// 	{
		// 		'class': 'col-12 searchajax__pagination'
		// 	}
		// )
		// const pagination_next = $('<a/>',
		// 	{
		// 		'class': 'searchajax__pagination--next btn btn-default blue-btn',
		// 		'data-direction': 'plus',
		// 		'href': '#'
		// 	}
		// )
		// pagination_next.text( 'Next' )
		//
		// const pagination_prev = $('<a/>',
		// 	{
		// 		'class': 'searchajax__pagination--prev btn btn-default blue-btn',
		// 		'data-direction': 'minus',
		// 		'href': '#'
		// 	}
		// )
		// pagination_prev.text( 'Prev' )
		// pagination_container.append( pagination_prev )
		// pagination_container.append( pagination_next )
		// all_elements.push( pagination_container );

		//self.all_elements = all_elements;

		self.order_results()
	}

	/**
	 * Request and return external search results from remote sites (VIA the JTF Search API in JTF3)
	 *
	 * @param target
	 * @param term
	 */
	SEARCH.prototype.get_external_posts = function ( target, term ) {
		var self = this

		//Strip URLS from incoming reference URL, or things break
		target = target.replace( 'https://', '' )
		target = target.replace( 'http://', '' )

		$.ajax( {
			url: AJAX_URL,
			type: 'GET',
			data: {
				search: encodeURIComponent( term ),
				url: 'https://' + target,
				api: 'search',
			},
		} ).success( function ( response ) {
			self.render_results( response, term, target )
		} )
	}

	// Check SEARCH is used on this page before instantiating
	if ( $( '.search-results' ).length > 0 ) {
		new SEARCH( $( this ) )
	}
} )

